<h1 class="stock-title">Stock Unit Search - Natis Documentation</h1>

@if (criteriaData) {
    <app-breadcrumb [externalData]="criteriaData"></app-breadcrumb>
}

<br/><br/>

<div style="display: flex; align-items: flex-end; gap: 1rem">
    <ds-form-field>
        <label ds-label for="search"> Search VIN </label>
        <input
                ds-input
                id="Search"
                type="text"
                placeholder="Enter search term (VIN, Model, Invoice...)"
                class="field_width"
                [(ngModel)]="searchTerm"
                (keyup.enter)="onSearch()"
        />
    </ds-form-field>
    <ds-form-field>
        <ds-button type="button" icon="search" class="btn_search" (click)="onSearch()">

            Search
        </ds-button>
    </ds-form-field>
    <ds-form-field *ngIf="searchTerm">
        <ds-button type="button" appearance="ghost" class="btn_search" (click)="clearSearch()">
            Clear
        </ds-button>
    </ds-form-field>
</div>

<br/><br/>
<div class="content_bg styled-section">
    <div class="mt-3"></div>
    @if (natisRows?.length === 0 && firstSearch) {
        <ng-container *ngTemplateOutlet="notYetSearched"></ng-container>
    } @else if (natisRows?.length === 0) {
        <ng-container *ngTemplateOutlet="noStock"></ng-container>
    } @else {

    <table class="ds-table zebra-table">
        <thead>
        <tr>
            <th>Image</th>
            <th>VIN</th>
            <th>Invoice</th>
            <th>Model</th>
            <th>Interior</th>
            <th>Exterior</th>
            <th>Released</th>
            <th>View Info</th>
            <th>Action</th>
        </tr>
        </thead>
        <tbody>
            @for (row of natisRows; track row['zvin']) {
                <tr>
                    <td>
                        @if (!row['image']) {
                            <ds-progress-circle
                                    size="sm"
                                    class="image-loader"
                            ></ds-progress-circle>
                        } @else {
                            <div class="image-popup-wrapper">
                                <img
                                        [src]="row['image']"
                                        alt="Image"
                                        width="80"
                                />
                                <div class="image-hover-popup">
                                    <img [src]="row['image']" alt="Vehicle Enlarged View"/>
                                </div>
                            </div>
                        }
                    </td>
                    <td>
                        <a
                                [href]="row['zvin'] | unitOverviewLink"
                                target="_blank"
                                rel="noopener"
                                class="vehicle-vin-link"
                                title="View Unit Overview"
                        ><strong>{{ row['zvin'] }} </strong></a>
                    </td>
                    <td>{{ row['zinvoice'] }}</td>
                    <td>{{ row['model'] }}</td>
                    <td>{{ row['interior'] }}</td>
                    <td>{{ row['exterior'] }}</td>
                    <td>{{ row['view'] }}</td>
                    <td>
                        <span title="Download Document">
                            <ds-icon
                                    icon="download"
                                    size="sm"
                                    class="download-icon"
                                    [disabled]="row['zreleased'] !== 'X'"
                                    (click)="downloadDocument(row['zvin'])"
                            ></ds-icon>
                        </span>
                    </td>
                    <td>
                        <button
                                ds-button
                                [disabled]="row['zreleased'] !== ''"
                                (click)="releaseVehicle(row['zvin'])"
                                class="release-btn"
                        >
                            Release
                        </button>
                    </td>
                </tr>
            }
        </tbody>
    </table>
    }
</div>

<ng-template #notYetSearched>
    <div
            class="no-data-message"
            style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      text-align: center;
      padding-left: 2rem;
    "
    >
        <div>
            <h1 style="margin: 0">NO SEARCH RESULTS YET</h1>
            <p style="margin: 0">
                Use the filters and click 'Search' to find what you need.
            </p>
        </div>
    </div>
</ng-template>
<ng-template #noStock>
    <div
            class="no-data-message"
            style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      text-align: center;
      padding-left: 2rem;
    "
    >
        <div>
            <h1 style="margin: 0">NO SEARCH RESULTS FOUND</h1>
            <p style="margin: 0"></p>
        </div>
    </div>
</ng-template>
